import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveLine } from 'cccisd-nivo/line';

const DetailChart = props => {
    const { title, description } = props.settings;
    const {
        totalAvg,
        data,
        reachedBenchmark,
        sessionDataVariables: { fidelityBenchmark, totalSessions, handle },
    } = props;

    return (
        <div
            style={{
                padding: '1em',
                border: '3px solid #007298',
                borderRadius: '10px',
                marginTop: '1em',
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <div style={{ width: '50%', fontFamily: 'Cabin' }}>
                <h3 style={{ color: '#007298' }}>{title}</h3>
                <p className="mb-1">{description}</p>
                <div className="d-flex justify-content-between">
                    <div className="text-center">
                        <span
                            className="fs-2 fw-bold"
                            style={{
                                color: totalAvg < fidelityBenchmark ? '#d03916' : '#3673b6',
                            }}
                        >
                            {totalAvg}%
                        </span>
                        <p className="mb-1">
                            <i>Average Across All Sessions</i>
                        </p>
                    </div>
                    <div className="text-center">
                        <span className="fs-2 fw-bold">{reachedBenchmark}</span> of{' '}
                        <span className="fs-2 fw-bold">{totalSessions}</span>{' '}
                        <p className="mb-1">
                            <i>Sessions at or Above Benchmark</i>
                        </p>
                    </div>
                </div>
            </div>

            <div style={{ height: '200px', width: '50%' }}>
                <ResponsiveLine
                    data={data}
                    legends={[]}
                    xFormat={d => `Session ${d}`}
                    theme={{ fontFamily: 'Cabin' }}
                    colors={{ scheme: 'category10' }}
                    markers={[
                        {
                            axis: 'y',
                            value: '80',
                            lineStyle: {
                                stroke: 'green',
                                strokeWidth: 1,
                            },
                        },
                    ]}
                    yScale={{
                        type: 'linear',
                        min: '0',
                        max: '100',
                    }}
                    xScale={{
                        type: 'linear',
                        min: '1',
                        max: handle === 'ssgrin_ec' ? '12' : '10',
                    }}
                    margin={{
                        bottom: 50,
                        left: 75,
                        right: 10,
                        top: 20,
                    }}
                    axisLeft={{
                        legend: 'Fidelity',
                        legendPosition: 'middle',
                        tickPadding: 10,
                        legendOffset: -50,
                        tickValues: ['20', '40', '60', '80', '100'],
                    }}
                    axisBottom={{
                        legend: 'Sessions',
                        legendPosition: 'middle',
                        tickPadding: 10,
                        legendOffset: 45,
                    }}
                />
            </div>
        </div>
    );
};

DetailChart.propTypes = {
    title: PropTypes.string,
    totalAvg: PropTypes.string,
    sessionDataVariables: PropTypes.object,
    settings: PropTypes.object,
    data: PropTypes.array,
    reachedBenchmark: PropTypes.number,
};

export default DetailChart;
